import Cookies from 'js-cookie';
import axios from 'axios';

export default class Language {
    constructor() {
        this.ALLOWED_ISO_CODES = ['gb', 'us'];

        this.LANGAUGES = {
            'gb': 'gb',
            'us': 'us'
        };
        this.DEFAULT_LANGUAGE = 'gb';
        this.initialised = false;
        if(!wordpress_globals.id) {
            throw new Error("Language - Ensure id is set as a wordpress global and links to the current page id.");
        }

        // this is a custom event in the OptanonWrapper in the headers/footers plugin
        window.addEventListener("OneTrustLoaded", event => {
            if (typeof OptanonActiveGroups !== undefined && OptanonActiveGroups.indexOf('C0003') !== -1) {
                this.init();
                this.initialised = true;
            }
        });

        window.addEventListener("OneTrustGroupsUpdated", event => {
            if (event.detail && event.detail.includes("C0003")) {
                this.init();
                this.initialised = true;
            }
        });
    }

    init () {
        // && !Cookies.get('lang_redirect_modal')
        if(!this.initialised && !Cookies.get('wp_user_logged_in') && !document.body.classList.contains('tax-work-category')) {
            this.getLanguage().then(lang => {
                console.log("Languages - current language is: " + lang);
                axios.post(window.location.origin + '/wp-json/languages/redirect', {
                    currLang: lang,
                    currPage: wordpress_globals.id,
                    isAdmin: wordpress_globals.is_admin,
                })
                  .then(res => {
                    // console.log('Language - data', res);
                    if (res.data.redirect && res.data.target_link && typeof res.data.target_link !== "undefined" && window.location.href !== res.data.target_link) {
                      window.location.href = res.data.target_link;
                    }
                        // if (res.data.redirect && res.data.target_link && typeof res.data.target_link !== "undefined" && window.location.href !== res.data.target_link) {
                        //     // JT - Current lang and target lang seem back to front to me, but this is how it was before
                        //     // so I am leaving it as is.
                        //
                        //     let currentLang = res.data.curr_lang === 'gb' ? 'UK' : 'US';
                        //     let targetLang = res.data.target_lang === 'us' ? 'US' : 'UK';
                        //
                        //     let currentISOlang = res.data.curr_lang === 'gb' ? 'en-GB' : 'en-US';
                        //
                        //     // Display a message to the user
                        //     const message = document.createElement('div');
                        //     message.className = 'modal switch-lang';
                        //     message.innerHTML = '<div class="modal__container" style="background-position: right center;"><div class="modal__content"><label>Switch region</label><p>You are currently viewing the ' + targetLang + ' version of the site, to switch to the ' + currentLang + ' version please click the link below.</p><div class="btn-group"><a href="#" class="btn close-modal">Stay on the ' + targetLang + ' site</a> <a href="' + res.data.target_link + '" lang="'+currentISOlang+'"class="btn">Switch to the ' + currentLang + ' version</a></div></div></div>';
                        //     document.body.appendChild(message);
                        //
                        //     // Add event listener to close the modal
                        //     const closeModal = message.querySelector('.close-modal');
                        //     closeModal.addEventListener('click', e => {
                        //         e.preventDefault();
                        //         message.remove();
                        //     });
                        //
                        //     // Set a cookie for 14 days to prevent showing the message again
                        //     Cookies.set('lang_redirect_modal', 'true', { expires: 14 });
                        // }
                  })
            });
        }
    }

    async getLanguage() {
        if(typeof geoip_detect === "undefined")
            return "gb";

        let lang = Cookies.get('lang');
        if(!lang) {
            //ignore the stupid documentation... The ajax_options filter doesn't work, there is literally a
            //js function to remove the local storage, no idea why this is mentioned nowhere...
            geoip_detect.remove_override();
            await geoip_detect.get_info().then(record => {
                let newLang = this.DEFAULT_LANGUAGE;

                if(record.error()) {
                    console.warn('Language - Failed to get language with error assuming ' + this.DEFAULT_LANGUAGE, record.error());
                }

                if(record.data && record.data.country && record.data.country.iso_code) {
                    newLang = record.data.country.iso_code;
                }

                if(!this.ALLOWED_ISO_CODES.includes(newLang.toLowerCase())) {
                    lang = this.DEFAULT_LANGUAGE;
                } else {
                    lang = this.LANGAUGES[newLang.toLowerCase()] ?? newLang.toLowerCase();
                }

                console.log("Language - setting language to " + lang);
                Cookies.set('lang', lang, { expires: 31 });
                Cookies.set('pll_language', lang, { expires: 31 });
            });
        }

        return lang;
    }
}
